// extracted by mini-css-extract-plugin
export default {"backBtn":"FormMobile_backBtn__WGgLT","text":"FormMobile_text__wZ5mN"};